import React from 'react';

const ScreenSharePermissionModal = ({
  isOpen,
  requestingUser,
  currentScreenSharer,
  onAccept,
  onDeny,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog">
        <h2 className='req-record'>Screen Share Permission Request</h2>
        <p className='record-call'>
          <strong>{requestingUser?.displayName || 'A user'}</strong> wants to share their screen.
        </p>
        {currentScreenSharer && (
          <p className='record-call' style={{ color: '#191C1B', fontSize: '14px' }}>
            If you accept, the current screen share by <strong>{currentScreenSharer.displayName}</strong> will be stopped and this user's screen share will start.
          </p>
        )}
        <div className='recrd-btn-align'>
          <button
            onClick={onAccept}
            className='allw-btn'
            style={{ color: '#FF1D1D' }}
          >
            Allow
          </button>
          <button
            onClick={onDeny}
            className='rej-btn'
            style={{ backgroundColor: '#0167FF', color: "#fff" }}
          >
            Deny
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScreenSharePermissionModal;
